/**
 * Carga SweetAlert2 solo cuando hay que mostrar un diálogo.
 * Evita incluirlo en el JavaScript inicial de la carta.
 */

export async function fireSwal(...args) {
  const { default: Swal } = await import("sweetalert2");
  return Swal.fire(...args);
}
